import AbstractController from '../src/services/ControllersRepository/AbstractController';

export default class Operations extends AbstractController {
    protected controllerName = 'Operations';
}
